module.exports = "/_next/static/images/transactions-99f0536cac2fe3c9ab71e4deb54bb139.svg";